import {
  CLEAR_TRANSACTIONS,
  GET_TRANSACTIONS_SUCCESS,
} from "../actions/transaction";

const initialState = {
  transactionData: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSACTIONS_SUCCESS:
      return { ...state, transactionData: action.payload };

    case CLEAR_TRANSACTIONS:
      return { ...state, transactionData: [] };

    default:
      return state;
  }
};
